export default {"src":"/_next/static/media/wordmark.229c011e.svg","height":351,"width":1912,"blurWidth":0,"blurHeight":0};